import { appConstants } from "../constants/appConstants"

const initialState = {
  userDetail: null,
  role: null,
  centerDetail: null,
  notificationList: [],
}

const userReducer = (
  state = initialState,
  action: any
) => {
  switch (action.type) {
    case appConstants.USER:
      return { ...state, userDetail: action.data }
    case appConstants.USER_ROLE:
      return { ...state, role: action.data }
    case appConstants.CENTER_DETAIL:
      return { ...state, centerDetail: action.data }
    case appConstants.READ_ONLY:
      return { ...state, readOnly: action.data }
    case appConstants.CURRENT_CENTER:
      return { ...state, role: action.data }
    case appConstants.NOTIFICATION:
      return { ...state, notificationList: action.data }
    case appConstants.RESET:
      return { ...initialState }
    default:
      return { ...state }
  }
}

export default userReducer
